<!-- One renderer for every kind of entry, so an external link, an in-app
     destination and a pure action all read identically in the panel and only
     differ in the element that carries the interaction. -->
<ng-template #menuBody let-item>
  @if (item.icon) {
    <i class="user-menu__icon" [sch-icon]="item.icon" aria-hidden="true"></i>
  }
  <span class="user-menu__text">
    <span class="user-menu__label">{{ item.label }}</span>
    @if (item.hint) {
      <span class="user-menu__hint">{{ item.hint }}</span>
    }
  </span>
  @if (item.external) {
    <i class="user-menu__external" [sch-icon]="'arrow-diagonal'" aria-hidden="true"></i>
  }
</ng-template>

<header class="header bg-primary shadow sticky top-0 lg:px-0 p-3">
  <div class="header-content">
    <div class="flex gap-1 items-center">
      <!-- Menu Icon, Logo, etc. -->

      <div class="logo-wrapper">
        <a [routerLink]="logoLink" role="button" class="logo-link">
          <img
            [src]="logoUrl"
            alt="logo"
            class="logo-link-img lg:h-[30px] lg:w-[80px] w-[58.46px] h-[20px]"
            />
        </a>
      </div>
    </div>

    <!-- Optional search bar -->
    @if (showSearch) {
      <div class="form-group" id="searchBar">
        <input
          type="text"
          class="form-control has-search"
          [placeholder]="searchPlaceholder"
          autocomplete="off"
          />
      </div>
    }

    <!-- User Profile Info -->
    <div id="navDropDown" class="user-nav">
      <seech-dropdown
        [disabled]="false"
        [direction]="'down'"
        [alignment]="'end'"
        [color]="'primary'"
        [fontColor]="'white'"
        [minWidth]="'19rem'"
        id="userProfileDropdown"
        >

        <!-- Toggle: the whole name-and-avatar pill is the target, rather than
             the avatar alone with a decorative rule beside it. -->
        <button
          toggle
          type="button"
          class="user-trigger"
          [attr.aria-label]="'Account menu for ' + displayName"
          >
          <span class="user-trigger__name">{{ user.username }}</span>
          <seech-avatar
            [name]="displayName"
            [imageUrl]="user.profileImageURL || null"
            size="md"
            [clickable]="false"
            id="profilePhoto">
          </seech-avatar>
          <i class="user-trigger__caret" [sch-icon]="'arrow-drop-down'" aria-hidden="true"></i>
        </button>

        <!-- Panel content. These are projected into the shared dropdown's own
             <ul>, so every entry has to be a direct <li>. -->
        <li class="user-menu__identity">
          <seech-avatar
            class="user-menu__identity-avatar"
            [name]="displayName"
            [imageUrl]="user.profileImageURL || null"
            size="lg"
            [clickable]="false">
          </seech-avatar>
          <span class="user-menu__identity-text">
            <span class="user-menu__identity-name">{{ displayName }}</span>
            @if (identitySubline) {
              <!-- Long addresses ellipsize in a 19rem panel, so the full value
                   stays reachable on hover rather than being simply lost. -->
              <span class="user-menu__identity-handle" [title]="identitySubline">{{
                identitySubline
              }}</span>
            }
            @if (userContext) {
              <span class="user-menu__identity-context">{{ userContext }}</span>
            }
          </span>
        </li>

        @for (group of menuGroups; track $index) {
          @if (!$first) {
            <li class="user-menu__rule" role="separator"></li>
          }
          @for (item of group; track item.label) {
            <li>
              @if (item.external && item.routerLink) {
                <a
                  class="dropdown-item user-menu__item"
                  [href]="item.routerLink"
                  [class.user-menu__item--danger]="item.tone === 'danger'"
                  >
                  <ng-container
                    *ngTemplateOutlet="menuBody; context: { $implicit: item }"
                  ></ng-container>
                </a>
              } @else {
                <button
                  type="button"
                  class="dropdown-item user-menu__item"
                  [class.user-menu__item--danger]="item.tone === 'danger'"
                  (click)="item.routerLink ? onMenuItemClick(item) : item.action?.()"
                  >
                  <ng-container
                    *ngTemplateOutlet="menuBody; context: { $implicit: item }"
                  ></ng-container>
                </button>
              }
            </li>
          }
        }
      </seech-dropdown>
    </div>
  </div>

  <!-- HTTP Progress Indicator -->
  <seech-http-progress-indicator></seech-http-progress-indicator>
</header>
